import React from "react";
import { FRAME_CSS } from "../../constants/FrameConstants";
import PropertyMaps from "../../constants/PropertyMaps";
import StyleUtils, { FORMAT_CSS } from "../../utils/StyleUtils";
import ThemeCSSGenerator from "../utils/ThemeCSSGenerator";

class EditorContentHeader extends React.Component {
  render() {
    const { elementId, layout, theme, linkStyle, designContext } = this.props;

    let tags = [];

    let css = FRAME_CSS.resetCSS;

    const themeInfo = ThemeCSSGenerator.generate(theme, layout, designContext);
    tags = tags.concat(themeInfo.tags);
    css += themeInfo.css;

    if (linkStyle) {
      css += StyleUtils.getStyleCSS(
        "#" + elementId + " a",
        StyleUtils.getStyle(PropertyMaps.STYLE_PROPS_LINK, linkStyle, theme, FORMAT_CSS)
      );
    }

    tags.push(
      <style
        key={"editor-style"}
        id="si_editor_style"
        type="text/css"
        dangerouslySetInnerHTML={{ __html: css }}
      ></style>
    );

    return (
      <div id="editor_header" style={{ display: "none" }}>
        {tags}
      </div>
    );
  }
}

export default EditorContentHeader;
